__turbopack_context__.v({
  "underline": "styles-module__hdN3kq__underline",
  "underline-fixed": "styles-module__hdN3kq__underline-fixed",
});
